const headerMobileElement = document.querySelector('.header-mobile');

export const initHeader = () => {
	if (headerMobileElement) {
		const burgerElement = headerMobileElement.querySelector('.header-mobile__button--burger');
		const menuElement = headerMobileElement.querySelector('.header-mobile__menu');
		const userElement = headerMobileElement.querySelector('.header-mobile__button--user');

		const onBurgerClick = () => {
			if (burgerElement.getAttribute('aria-expanded') === 'false') {
				document.body.classList.add('disable-scroll');
				burgerElement.setAttribute('aria-expanded', 'true');
				menuElement.classList.add('header-mobile__menu--opened');
				userElement.style.pointerEvents = 'none';
				userElement.querySelector('.o2k-icon').style.display = 'none';
			} else {
				document.body.classList.remove('disable-scroll');
				burgerElement.setAttribute('aria-expanded', 'false');
				menuElement.classList.remove('header-mobile__menu--opened');
				userElement.style.pointerEvents = 'visible';
				userElement.querySelector('.o2k-icon').style.display = 'flex';
			}
		};

		burgerElement.addEventListener('click', onBurgerClick);

		const headerDesktopElement = document.querySelector('.header-desktop');
		const headerStickyElement = document.querySelector('.header-sticky');

		const onHeaderScroll = () => {
			const desktopHeight = headerDesktopElement.clientHeight;
			if (window.scrollY > desktopHeight + 40) {
				if (!headerStickyElement.classList.contains('header-sticky--visible')) {
					headerStickyElement.classList.add('header-sticky--visible');
				}
			} else {
				if (headerStickyElement.classList.contains('header-sticky--visible')) {
					headerStickyElement.classList.remove('header-sticky--visible');
				}
			}
		};

		window.addEventListener('scroll', onHeaderScroll);
	}
};
